import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';

function Explanation(props) {
  return (
    <CSSTransitionGroup
    className="container"
    component="div"
    transitionName="fade"
    transitionEnterTimeout={2000}
    transitionLeaveTimeout={1500}
    transitionAppear
    transitionAppearTimeout={1500}
    >
    <div id="wrapper" class="pt_category_landing_nonav pt_shadefinder FentyFace2">
        <main class="clearfix">
            <div id="browser-check">
                <noscript>
                    <div class="browser-compatibility-alert">
                        <p class="browser-error">Your browser's Javascript functionality is turned off. Please turn it on so that you can experience the full capabilities of this site.</p>
                    </div>
                </noscript>
            </div>
            <div id="primary" class="primary-content">
                <div className="finderholder" style={{ minWidth: 1519 + 'px', maxWidth: 1519 + 'px' }}>
            <div className="screenreader-text" aria-live="polite">Next button is now selectable</div>
            <div className="slideContainer step statementlayout1" id="s2" style={{ width: 1519 + 'px' }}>
                <div className="content-wrapper">
                    <div id="product-finder-makeup-shop-all-s2" className="content-asset  ">
                        <div className="wrapper">
                            <div className="statementHead">
                                <div className="statementImage desktop">
                                    <img alt="" src="https://i.imgur.com/6FrPD0Y.jpg" title="Fenty Face finder Perfect Page Perfect" />
                                </div>
                                <div id="finderHeaderWrapper">
                                    <h2 className="finderHeader">Bovanti Face Shade Finder</h2>
                                    <div className="progressBarHolder">
                                        <style type="text/css"/>
                                        <div id="product-finder-progress-bar" className="content-asset  ">
                                            <div className="progressBar">
                                                <span className="bar">
                                                    <span className="fill" style={{ width: 18.1818 + '%' }}/>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="hexagon_wrapper" className="desktop">
                                    <svg id="color-fill" xmlns="http://www.w3.org/2000/svg" version="1.1" width="%" viewBox="0 0 300 280">
                                        <path stroke="#FFFFFF" fill="none" d="M25,15 0,60" vector-effect="non-scaling-stroke"/>
                                        <path stroke="#FFFFFF" fill="none" d="M25,280 0,250" vector-effect="non-scaling-stroke"/>
                                        <path stroke="#FFFFFF" fill="none" d="M225,20 300,150 225,280" vector-effect="non-scaling-stroke">
                                        </path>
                                    </svg>
                                </div>
                                <div id="inside_hexagon_wrapper" className="desktop">
                                    <svg id="color-fill" xmlns="http://www.w3.org/2000/svg" version="1.1" width="%" viewBox="0 0 300 280">
                                        <polygon className="hex" points="300,150 225,280 75,280 0,150 75,20 225,20"/>
                                    </svg>
                                </div>
                                <div id="text">
                                    <div className="statementHeader">ALL GOOD.</div>
                                    <div className="statementTextWrapper">
                                        <div tabindex="0" className="statementText">Answer 6 easy questions to&nbsp;find&nbsp;your foundation&nbsp;match. Need
                                            product recos, too? <span className="">
                                                <br/></span> We got you.</div>
                                        </div>
                                </div>
                            </div>
                            <div className="statementImage mobile">
                                <img alt="" src="https://www.fentybeauty.com/on/demandware.static/-/Sites-FENTY-Library/default/dwa76789e4/fentyface2/perfect/mobile/FB_SP19_T1BEAUTY_2000X2500_300DPI.png" title="Fenty Face finder Perfect Page Perfect" />
                            </div>
                            <div className="btnHolder sticky wrapper buttons fixed">
                                <div className="back">
                                    <a onClick={props.onBackSelected} tabindex="0" aria-label="Go to previous step" className="btnBack" data-step="q1">
                                        <span>Back</span>
                                        <svg id="color-fill" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" viewBox="0 0 300 280">
                                            <polygon className="hex" points="300,150 225,280 75,280 0,150 75,20 225,20"/>
                                        </svg>
                                    </a>
                                </div>
                                <div className="next">
                                    <a onClick={props.onContinueSelected} tabindex="0" aria-label="Proceed to next step" className="btnNext" data-step="no-q2" aria-hidden="false">
                                        <span>Next</span>
                                        <svg id="color-fill" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" viewBox="0 0 300 280">
                                            <polygon className="hex" points="300,150 225,280 75,280 0,150 75,20 225,20"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            </div>
        </main>
    </div>
    </CSSTransitionGroup>
  );
}

Explanation.propTypes = {
    onContinueSelected: PropTypes.func.isRequired,
    onBackSelected: PropTypes.func.isRequired
};

export default Explanation;